import React from 'react';
import { FUNDING_AI_ADVISOR_PRIORITIES, FUNDING_AI_ADVISOR_STATUSES } from '../../utils/funding/constants';

const styles = {
  Low: 'bg-slate-100 text-slate-700 dark:bg-slate-900/40 dark:text-slate-200',
  Medium: 'bg-[var(--fg-accent-soft)] text-[var(--fg-accent)]',
  High: 'bg-amber-50 text-amber-800 dark:bg-amber-950/40 dark:text-amber-200',
  Critical: 'bg-rose-50 text-rose-800 dark:bg-rose-950/40 dark:text-rose-200',
};

const FundingAIRecommendationBadge = ({ priority, category, status }) => {
  const label = priority || category || status || 'Open';
  const style = styles[priority] || FUNDING_AI_ADVISOR_STATUSES.includes(status)
    ? 'bg-[var(--fg-panel-soft)] text-[var(--fg-muted)]'
    : styles.Medium;

  return (
    <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${style}`}>
      {label}
    </span>
  );
};

export default FundingAIRecommendationBadge;
